import React, { useEffect, useState } from "react";
import Loadspinner from "../common/Loadspinner";
import Main from "../common/Main/Main";
import GuidelinesService from "../services/GuidelinesService";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import CircleIcon from '@mui/icons-material/Circle';
import { APICall } from "../helpers/API/APICalls";
import { getGuidelineAllData } from "../helpers/API/APIEndPoints";

const sampleData = [{
  id: 1, question: '1) What is mKisan?', answer: 'Mkisan is portal to capture the tacit knowledge lying in our organization.'

},
{
  id: 2, question: '2) What Is tacit knowledge?',
  answer: 'Tacit knowledge encompasses everything a person knows how to do but does not necessarily know how to explain or has taken the time to try to document. It can be defined as skills, ideas and experiences that people have but are not written down and may not be captured easily.'

},
{
  id: 3, question: '3) How can be the tacit knowledge be captured?', answer: 'The tacit knowledge can be captured as Videos, Recording, Images and text.'
},
{
  id: 4, question: '4) Can this portal be used for promotion of Jobs and other personal content?', answer: 'No, this portal is highly restricted to capturing of Tacit knowledge and retracting he same.'
},
{
  id: 5, question: '5) Can Explicit knowledge can be captured in the same portal?', answer: 'No, Explicit knowledge should be captured in separate portal as given below.'
},
{
  id: 6, question: '6) Where should be the learnings be recorded?', answer: 'If possible, Record the video and audio in a closed environment to avoid the noise disturbance from external sources.'
},
{
  id: 7, question: '7) How to get the content of your favorite choice in my feed?', answer: 'Do complete your profile correctly for getting regular updates on your favorite topics.'
},
{
  id: 8, question: '8) How to get correct answers from Ask an expert’s options?', answer: 'Please mention your problems accurately and if possible, please attach photo or video for clear understanding. If possible pls add any technical specs with it.'
}

]

function Guidelines() {
  const [data, setData] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState(0);


  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };


  useEffect(() => getData(), []);

  const getData = async () => {
    setLoading(true);
    //   const res = await GuidelinesService.getGuidelines();

    //   if (res) {
    //     setData(res);
    //     setLoading(false);
    //   }


    let res = await APICall(getGuidelineAllData);
    if (res.message === "Ok") {
      if (res && res.data.length > 0) {


        setData(res.data[0]);
      }
    }

    setLoading(false)
  };
  console.log(data)
  return (
    <Main active="guidelines">
      <Loadspinner filename="Guidelines.js" isLoading={isLoading} isMiddle="false" />
      {/* <div dangerouslySetInnerHTML={{ __html: data }} /> */}

      {/* <img src={images.coming_soon} style={{ width: "60vw", height: "35vw" }} /> */}

      <div style={{ width: '60vw', marginTop: '1rem' }}>

        {data.length > 0 ?
          data.map((item, i) => (
            <Accordion key={item.id} expanded={expanded === i} onChange={handleChange(i)} >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography><strong>{(i + 1)}) {item.Question}</strong></Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  {item.Answer}
                  {/* {item.id === 5 && (
               <List>
                 <ListItem >
                  <CircleIcon sx={{height:'10px', width:'10px'}}/>
                  <ListItemText sx={{marginLeft:'10px'}} primary= 'TGR/TGW – Lessons learnt -Teamcenter'/>
                   
                 </ListItem>
                 <ListItem >
                  <CircleIcon sx={{height:'10px', width:'10px'}}/>
                  <ListItemText sx={{marginLeft:'10px'}} primary= 'Standards – Teamcenter'/>
                   
                 </ListItem>
                 <ListItem >
                  <CircleIcon sx={{height:'10px', width:'10px'}}/>
                  <ListItemText sx={{marginLeft:'10px'}} primary= 'Knowledge from external experts – KSS portal'/>
                   
                 </ListItem>
                 </List>
             )} */}
                </Typography>
              </AccordionDetails>
            </Accordion>

          )) : null}


      </div>
    </Main>
  );
}

export default Guidelines;
